var map = {
	"./citylife.gif": 6245,
	"./datespot.gif": 5846,
	"./frostymountains.gif": 659,
	"./latenightwalk.gif": 839,
	"./naturehearh.gif": 9013,
	"./parkwalk.gif": 1193,
	"./vacationhouse.gif": 2597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7279;